import { render, staticRenderFns } from "./section-content.vue?vue&type=template&id=5a2c8df0&scoped=true"
import script from "./section-content.vue?vue&type=script&lang=js"
export * from "./section-content.vue?vue&type=script&lang=js"
import style0 from "./section-content.vue?vue&type=style&index=0&id=5a2c8df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c8df0",
  null
  
)

export default component.exports